module.exports = __webpack_public_path__ + "static/media/globe-snow.da17a212.svg";